import React from 'react'
import GithubSlugger from 'github-slugger'

import FaqPostPageLayout from '../layouts/FaqPostPageLayout'
import NavBreadCrumb from '../components/NavBreadCrumb'
import SectionLink from '../components/SectionLink'

export default function Template ({
  data,
}) {
  const { markdownRemark } = data
  const { frontmatter, html, headings } = markdownRemark
  const h1s = headings.filter(x => x.depth === 1)
  const slugger = new GithubSlugger()

  return (
    <FaqPostPageLayout>
      <div className="row">
        <NavBreadCrumb currentRouteName={frontmatter.title} />
      </div>
      <div className="row" id="faq-post">
        <div className="col-12 col-md-3 post-nav-container">
          <div className="nav-heading">Sections:</div>
          {h1s.map(h => {
            const id = slugger.slug(h.value)
            return <SectionLink key={id} scrollTo={id} name={h.value} />
          })}
        </div>
        <div className="col-12 col-md-9 post-content-container">
          <div className="title">{frontmatter.title}</div>
          <div className="date">Updated on {frontmatter.date}</div>
          <article
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </div>
      </div>
    </FaqPostPageLayout>
  )
}

export const pageQuery = graphql`
  query FaqPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      headings {
        depth
        value
      }
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/faqPostTemplate.js